import { useState } from 'react';
import { useSelector } from 'react-redux';
import { deleteRecepcionVehiculo } from '../../helpers/api_helper';

const useDeleteRecepcionVehiculo = () => {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const tenantId = useSelector((state) => state.Context.tenantId);
    const empresa = useSelector((state) => state.Context.empresa);
    const departamento = useSelector((state) => state.Context.departamento);

    const deleteRecepcionHook = async (id) => {
        setLoading(true);
        setError(null);
        try {
            const params = { tenantId, empresa, departamento };
            const response = await deleteRecepcionVehiculo(id, params);
            return { success: true, data: response };
        } catch (err) {
            const errorMessage = `Failed to delete recepcion: ${err.message || 'Unknown error'}`;
            setError(errorMessage);
            console.error(errorMessage);
            return { success: false, error: errorMessage };
        } finally {
            setLoading(false);
        }
    };

    return { deleteRecepcion: deleteRecepcionHook, loading, error };
};

export default useDeleteRecepcionVehiculo;
